<template>
  <section>
    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <p class="level-item">
          <a class="button is-primary" @click="onSave">
            {{ $t('attributes.save') }}
          </a>
        </p>
      </div>
    </nav>

    <b-table
      :data="items"
      :loading="sending"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column label="眷屬" v-slot="props">
        {{ props.row.index !== -1 ? `第${props.row.index + 1}位` : '?' }}
      </b-table-column>

      <b-table-column
        field="subsidy"
        :label="$t('attributes.subsidy')"
        v-slot="props"
      >
        <b-field>
          <b-input
            v-model.number="props.row.subsidy"
            type="number"
            :placeholder="$t('attributes.subsidy')"
          ></b-input>
        </b-field>
      </b-table-column>

      <b-table-column :width="90" v-slot="props">
        <b-button
          v-if="props.row.index === -1"
          type="is-warning"
          @click.prevent="onAdd(props.row)"
        >
          {{ $t('attributes.add') }}
        </b-button>
        <b-button v-else type="is-danger" @click.prevent="onDelete(props.row)">
          {{ $t('attributes.delete') }}
        </b-button>
      </b-table-column>
    </b-table>
  </section>
</template>

<script>
import { FIRM_COLLABORATES_ACTIVITIES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'ActivityDependentForm',

  props: {
    id: {
      required: true,
      type: Number,
      default: null
    }
  },
  data() {
    return {
      sending: false,
      items: []
    }
  },
  watch: {
    id() {
      this.fetchData()
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const api = `${FIRM_COLLABORATES_ACTIVITIES_API}/${this.id}`

      this.sending = true
      try {
        const res = await this.axios.get(api)
        const data = res.data.data

        this.items = data.dependents.map((subsidy, index) => {
          return {
            index,
            subsidy
          }
        })

        this.addNewSubsidyItem()
      } catch (e) {
        this.items = []

        notifyService.fetch_error('collaborate_activity', e)
      } finally {
        this.sending = false
      }
    },
    addNewSubsidyItem() {
      this.items.push({
        index: -1,
        subsidy: 0
      })
    },
    onAdd(item) {
      if (item.subsidy === 0) {
        return
      }

      item.index = this.items.length - 1
      this.addNewSubsidyItem()
    },
    onDelete(item) {
      const items = [
        ...this.items.slice(0, item.index),
        ...this.items.slice(item.index + 1, -1)
      ]

      this.items = items.map((item, index) => ({
        index,
        subsidy: item.subsidy
      }))

      this.items.push({ index: -1, subsidy: 0 })
    },
    async onSave() {
      const api = `${FIRM_COLLABORATES_ACTIVITIES_API}/${this.id}/dependents`

      const dependents = this.items
        .filter(item => item.subsidy > 0)
        .map(item => item.subsidy)
      const data = {
        dependents: JSON.stringify(dependents)
      }

      this.sending = true
      try {
        const res = await this.axios.put(api, data)

        this.items = res.data.data.dependents.map((subsidy, index) => {
          return {
            index,
            subsidy
          }
        })
        this.addNewSubsidyItem()

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  min-width: 960px;
  min-height: 540px;

  .table {
    td {
      vertical-align: middle;

      .control {
        margin: -0.5rem -0.75rem;
      }
    }
  }
}

@media (max-width: 960px) {
  .modal-card {
    min-width: 760px;
  }
}

@media (max-width: 768px) {
  .modal-card {
    min-width: auto;
  }
}
</style>
